import { useState } from "react";
import { Plus, Trash2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import DateField from "./DateField";
import { DAYS } from "./helpers";

const fmt = (v) => new Date(`${v}T12:00:00`).toLocaleDateString("it-IT");

export const hoursToText = (h) => (h || []).map(([a, b]) => `${a}-${b}`).join(", ");
export const textToHours = (t) => (t || "").split(",").map((x) => x.trim()).filter(Boolean).map((x) => x.split("-").map((y) => y.trim()));

export function WeeklyHours({ value, onChange }) {
  const set = (d, txt) => onChange({ ...value, [d]: txt });
  return (
    <div className="space-y-1.5" data-testid="unit-weekly">
      {DAYS.map((name, i) => (
        <div key={i} className="flex items-center gap-3">
          <span className="w-24 text-xs text-slate-600">{name}</span>
          <Input value={value[i] ?? ""} onChange={(e) => set(i, e.target.value)} placeholder="chiuso" className="h-8 text-xs" data-testid={`unit-weekly-${i}`} />
        </div>))}
      <p className="text-[11px] text-slate-500">Formato: 09:00-13:00, 14:00-18:00 (minuti a multipli di 5). Vuoto = chiuso.</p>
    </div>
  );
}

export function DateRows({ rows, onChange, kind, testid }) {
  const [draft, setDraft] = useState(kind === "exception" ? { date: "", hours: "" } : { from: "", to: "", label: "" });
  const add = () => { onChange([...rows, draft]); setDraft(kind === "exception" ? { date: "", hours: "" } : { from: "", to: "", label: "" }); };
  const ok = kind === "exception" ? !!draft.date : draft.from && draft.to;
  return (
    <div className="space-y-1.5" data-testid={testid}>
      {rows.map((r, i) => (
        <div key={i} className="flex items-center gap-2 text-xs text-slate-700">
          <span className="flex-1">{kind === "exception" ? `${fmt(r.date)} · ${r.hours ? r.hours : "chiuso"}` : `${fmt(r.from)} → ${fmt(r.to)}${r.label ? ` · ${r.label}` : ""}`}</span>
          <button onClick={() => onChange(rows.filter((_, j) => j !== i))} className="text-slate-400 hover:text-red-600" aria-label="Rimuovi" data-testid={`${testid}-remove-${i}`}><Trash2 size={13} /></button>
        </div>))}
      <div className="flex flex-wrap items-center gap-2">
        {kind === "exception" ? <>
          <DateField value={draft.date} onChange={(v) => setDraft({ ...draft, date: v })} testid={`${testid}-date`} />
          <Input value={draft.hours} onChange={(e) => setDraft({ ...draft, hours: e.target.value })} placeholder="vuoto = chiuso, o 10:00-12:00" className="h-8 flex-1 min-w-40 text-xs" data-testid={`${testid}-hours`} />
        </> : <>
          <DateField value={draft.from} onChange={(v) => setDraft({ ...draft, from: v, to: draft.to && draft.to >= v ? draft.to : v })} placeholder="dal" testid={`${testid}-from`} />
          <DateField value={draft.to} min={draft.from} onChange={(v) => setDraft({ ...draft, to: v })} placeholder="al" testid={`${testid}-to`} />
          <Input value={draft.label} onChange={(e) => setDraft({ ...draft, label: e.target.value })} placeholder="Motivo (es. ferie)" className="h-8 flex-1 min-w-32 text-xs" data-testid={`${testid}-label`} />
        </>}
        <Button type="button" size="sm" variant="outline" disabled={!ok} onClick={add} data-testid={`${testid}-add`}><Plus size={13} /></Button>
      </div>
    </div>
  );
}
